import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import LatestUpdates from './components/LatestUpdates';
import CategoryBrowsing from './components/CategoryBrowsing';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/data';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteInfo.name} - 在线免费阅读漫画`,
    description: siteInfo.description,
    url: siteInfo.url,
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: siteInfo.url,
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <LatestUpdates />
        <CategoryBrowsing />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}